import { CLOSE_DEAL } from './closeDeal';
import { REOPEN_DEAL } from './reopenDeal';

export const dealLifeCycleApi = {
  closeDeal: CLOSE_DEAL,
  reopenDeal: REOPEN_DEAL,
};

export * from './types';
export * from './useDealLifeCycle';
